import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  standalone: false
})
export class CardComponent implements OnInit {
 
  // data=
  //   {
  //   "Product type":'type',
  //   "Product name":'name',
  //   "Product category":'product category',
  //   "Product price":'product price',
  //   "Product note":'this is note',

  // }
  @Input()   data:any={};
  keys:any=[];
  id:any;
  constructor() {
    
   }
  

  ngOnInit() {
    // this.id=this.data.id;
    // delete this.data.age; 
    // delete this.data.id;
    this.id=this.data.id;
    
    // delete this.data.id;

    this.keys = Object.keys(this.data);
    
    
    const index = this.keys.indexOf('id');
if (index > -1) { // only splice array when item is found
  this.keys.splice(index, 1); // 2nd parameter means remove one item only
}
    // this.keys.shift()
    // console.log(this.keys)
  }


}
